<mat-toolbar class="header">
    <img class="header-brand-logo" src="./assets/gem_500x500.svg">
    <div>
        <span class="header-brand-title"> gem-lpb.com </span>
        <span class="header-brand-subtitle"> <i>&mdash; Your site for exchanging LPB-format (IEC63055/IEEE2401)</i></span>
    </div>
</mat-toolbar>
<alert></alert>
